import { Helmet } from 'react-helmet-async'
import ProtectedRoute from '../components/auth/ProtectedRoute'
import { AppHeader } from '../components'
import { HeadToHead } from '../components/headtohead/HeadToHead'

export default function HeadToHeadPage() {
  return (
    <ProtectedRoute>
      <Helmet>
        <title>Head-to-Head Comparison - FWO Pilot Portal</title>
        <meta name="description" content="Side-by-side pilot comparison across all competition tasks" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        <AppHeader activePage="head-to-head" />

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-1">Head-to-Head Comparison</h2>
            <p className="text-gray-600">Compare two pilots side-by-side across all competition tasks.</p>
          </div>

          <HeadToHead />
        </main>
      </div>
    </ProtectedRoute>
  )
}
